import React, { Component } from "react";
import { connect } from "react-redux";
import produce from "immer";
import CreatePromotion from "../../store/prat_middleware/promotion/createPromotionMiddleware";
import { openDB } from "idb";

import "./style/promotion.scss";
import { Loader } from "../../components/loader";
import ANP from './preOPSOTypeBreakdown/anp';
import SBB from './preOPSOTypeBreakdown/sbb';
import TPR from './preOPSOTypeBreakdown/tpr';
import MSKUS from './preOPSOTypeBreakdown/mskus';
import TOTALROW from './preOPSOTypeBreakdown/total';
import CustomToast from '../../util-functions/customToast.jsx'
import PromotionMiddleware from '../../store/prat_middleware/gt/promotionMiddleware';
import CSVReader from "react-csv-reader";
import CSVErrorTable from './CSVErrorTable';

let preOpsoData = [];       // eslint-disable-line
// let isSaveDraft = false;
let selectedProjectForNewCode = undefined;
let selectedMskuForNewCode = undefined;
let selectedNormValueForNewProject = undefined;
let selectedNormTypeValueForNewProject = undefined;
let selectedmskuIndex = undefined;
let selectedpromotionIndex = undefined;
class Promotion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRestrict_fromIdb: '',
      selectedStartWeek: "",
      selectedEndWeek: "",
      checked: false,
      switch: false,
      startDate: "",
      endDate: "",
      sync: false,
      expanded: false,
      indexing: [],
      data: undefined,
      isLoading: false,
      selectedAppyUom: "",
      selectedBuyType: "",
      selectedBuyUom: "",
      selectedDiscountType: "",
      selectedUom: "",
      selectedAppyOn: "",
      selectedSkuNormType: "",
      budgetRestriction: "isEmpty",
      skuNorm: "isEmpty",
      postAws: "isEmpty",
      activatedAws: "isEmpty",
      buyFrom: "isEmpty",
      buyTo: "isEmpty",
      awsBaseline: "isEmpty",
      otherDetails: "",
      norm: "isEmpty",
      dnds: "isStatic",
      total_vol: "isStatic",
      selectedSkuNormType_label: "",
      extra_profit: "isStatic",
      ROI: "isStatic",
      newPromotion: [],
      sku_uniqueIndex: "",
      draft: undefined,
      slabFrom: "isEmpty",
      slabTo: "isEmpty",
      slabNorm: "isEmpty",
      metaData: undefined,
      TotalBudget: "",
      TotalVolume: "",
      TotalCost: "",
      noNewProject: false,
      isPercentageValue: false,
      isMerge: false,
      iscalc: false,
      trash: false,
      isCalculationResult: false,
      selectedProjectForNewCode: undefined,
      selectedMskuForNewCode: undefined,
      selectedValueForNewProject: undefined,
      selectedmskuIndex: undefined,
      selectedpromotionIndex: undefined,
      forceState:false,
      testing:undefined,
      CSVHasError:false,
      CSVData: null
    };
  }

  onChange = (e, index) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  baselineChange = (e, index, pind) => {
    const { data } = this.state;
    let value = e.target.value;
    value = parseFloat(value);
    this.setState(
      produce((prevState) => {
        const object3 = Object.create(data);
        prevState.data = object3;
        prevState.data.Promotions[pind].SkuVolumeAnalysis[
          index
        ].Baseline = value;
      }),
      () =>
        this.dndsVal(
          data.Promotions[pind].SkuVolumeAnalysis[index],
          pind,
          index,
          data.ActivityDuration
        ) // here sequesncy is pre activated weeks, activated weks, dip weeks
    );
  };
  dndsVal(api, promotion_index, sku_index, ActivityDuration,normm) {
    const { data } = this.state;
    let dnds =
      (api.PreActivityWeeks + ActivityDuration + api.DipWeeks) * api.Baseline;
      this.setState(
      produce((prevState) => {
        prevState.data.Promotions[promotion_index].SkuVolumeAnalysis[sku_index].DndsVolume = !dnds ? 0 : dnds.toFixed(2) * 1;
        prevState.testing = true
      }),
      () =>
        {
          this.totalVol(api, promotion_index, sku_index, data.ActivityDuration)}
    );

  }

  awsChange = (e, index, prom_ind) => {
    const { data } = this.state;
    let value = e.target.value;
    value = parseFloat(value);
    this.setState(
      produce((prevState) => {
        const awschange_object4 = Object.create(data);
        prevState.data = awschange_object4;
        prevState.data.Promotions[prom_ind].SkuVolumeAnalysis[index].ActivatedAws = value;
      }),
      () =>
        this.totalVol(
          data.Promotions[prom_ind].SkuVolumeAnalysis[index],
          prom_ind,
          index,
          data.ActivityDuration
        ) // here sequesncy is pre activated weeks, activated weks, dip weeks
    );
  };

  post_awsChange = (e, index, prom_index) => {
    const { data } = this.state;
    let value = e.target.value;
    value = parseFloat(value);
    this.setState(
      produce((prevState) => {
        const postchange_object4 = Object.create(data);
        prevState.data = postchange_object4;
        prevState.data.Promotions[prom_index].SkuVolumeAnalysis[
          index
        ].PostAws = value;
      }),
      () =>
        this.totalVol(
          data.Promotions[prom_index].SkuVolumeAnalysis[index],
          prom_index,
          index,
          data.ActivityDuration
        )
      // here sequesncy is pre activated weeks, activated weks, dip weeks
    );
  };

  totalVol(api, promotion_index, sku_index, ActivityDuration) {
    let norm_delta = (api.Norm / api.OrgNorm) * 100;
    let total_activatedVol = api.ActivatedAws * ActivityDuration
 
    let total_vol = api.PreActivityWeeks * api.Baseline +
      ActivityDuration * (api.ActivatedAws + api.Baseline) + (api.DipWeeks * api.PostAws);

    let incValue = total_vol - api.DndsVolume; // this is also extra volume
    let extra_profit = (incValue.toFixed(2) * 1) * api.GpTon * 1000; // this is also extra profit
    
    if (this.state.data.Promotions[promotion_index] && this.state.data.Promotions[promotion_index].SkuVolumeAnalysis) {
      this.setState(
        produce((prevState) => {
          prevState.data.Promotions[promotion_index].SkuVolumeAnalysis[sku_index].TotalActivatedVolume = !total_activatedVol ? 0 : total_activatedVol.toFixed(2) * 1;
          prevState.data.Promotions[promotion_index].SkuVolumeAnalysis[sku_index].IncVolume = !incValue ? 0 : incValue.toFixed(2) * 1;
          prevState.data.Promotions[promotion_index].SkuVolumeAnalysis[sku_index].TotalVolume = !total_vol ? 0 : total_vol.toFixed(2) * 1;
          prevState.extra_profit = extra_profit.toFixed(2) * 1;
          prevState.data.Promotions[promotion_index].SkuVolumeAnalysis[sku_index].Percentage = !norm_delta ||
            norm_delta === 'Infinity' ? 0 : norm_delta.toFixed(2) * 1;

        }),
        () => this.totalCost(api, promotion_index, sku_index, ActivityDuration,extra_profit) // here sequesncy is pre activated weeks, activated weks, dip weeks
      );
    }

  }

  totalCost(api, promotion_index, sku_index, ActivityDuration,extra_profit) {
    try {
      this.calculateTotalCost(api, promotion_index, sku_index, ActivityDuration,extra_profit)
    }
    catch (e) {
    }
  }

  calculateTotalCost=(api, promotion_index, sku_index, ActivityDuration,extra_profit)=>{
    // !api.Grammage && ToastsStore.warning(`there is no gramage in msku ${sku_index}`)
    !api.Grammage && CustomToast('warning', `there is no gramage in msku ${sku_index}`)
    const {
      // extra_profit,
      data,
    } = this.state;
    let total_act_vol = (api.Baseline + api.ActivatedAws) * ActivityDuration
    // let totalVol_value = parseFloat(api.TotalVolume);
    // let norm_value = !api.Norm ? 2 : api.Norm;      //removed this because of 2
    let norm_value = api.Norm;
    if (data.Promotions[promotion_index].NormType === "b2e41bb3-a11d-48f1-b041-b9c04c956e7a") {
      let firstType =
        norm_value * total_act_vol * (api.Pricing * 1000 / api.Grammage);
      this.setState(
        produce((prevState) => {
          prevState.data.Promotions[promotion_index].SkuVolumeAnalysis[sku_index].TotalCost = !firstType ? 0 : firstType.toFixed(2) * 1;
        })
      );
    }
    if (data.Promotions[promotion_index].NormType === "2a48252b-4179-4090-98ac-a437728d5ed6" || data.Promotions[promotion_index].Slabs) {
      let secondType = parseFloat(norm_value) * total_act_vol * ((api.Pricing * 1000) / (100 * api.Grammage));
      this.setState(
        produce((prevState) => {
          prevState.data.Promotions[promotion_index].SkuVolumeAnalysis[sku_index].TotalCost = !secondType ? 0 : secondType.toFixed(2) * 1;
        })
      );
    }
    if (data.Promotions[promotion_index].NormType === "608618a4-50a0-4b2c-bdb1-8eac4e5e3238") {
      let thirdType = (norm_value * 1000 / api.Grammage) * total_act_vol;
      this.setState(
        produce((prevState) => {
          prevState.data.Promotions[promotion_index].SkuVolumeAnalysis[
            sku_index].TotalCost = !thirdType ? 0 : thirdType.toFixed(2) * 1;
        })
      );
    }
    let roiNumerator;
    setTimeout(() => {

      roiNumerator = extra_profit - api.TotalCost;
      let roi = 100 * roiNumerator.toFixed(2) * 1 / api.TotalCost;
      this.setState(
        produce((prevState) => {
          let createObj = Object.create(data);
          prevState.data = createObj;
          prevState.data.Promotions[promotion_index].SkuVolumeAnalysis[sku_index].Roi = roi.toFixed(2) * 1;
          prevState.data.Promotions[promotion_index].SkuVolumeAnalysis[sku_index].RoiNumerator = roiNumerator;
        })
      );
      // let calProjectRoi = true ? true : false;
      if (api.TotalCost && roiNumerator) {
        // calProjectRoi = true;
        this.projectRoi(sku_index, promotion_index, api, roiNumerator);
      }

    }, 0);
  }

  projectRoi(sku_index, promotion_index, api, roiNumerator) {
    const { data } = this.state;
    let sum_totalCost = [0];
    let roi_numerator = [0];
    for (
      let i = 0;
      i < data?.Promotions[promotion_index]?.SkuVolumeAnalysis.length;
      i++
    ) {
      let sku = data?.Promotions[promotion_index]?.SkuVolumeAnalysis[i];
      let constint = parseFloat(sku.TotalCost);
      sum_totalCost.push(constint);
      if (!sku.RoiNumerator) {

        let extraprofit = (parseFloat(sku.IncVolume)) * sku.GpTon * 1000;
        let sku_roinumerator = extraprofit - constint;
        roi_numerator.push(sku_roinumerator);
      } else {
        if (
          roi_numerator.length - 1 <=
          data?.Promotions[promotion_index]?.SkuVolumeAnalysis.length
        ) {
        
          roi_numerator.push(sku.RoiNumerator);
        } else {
        }
        // alert("hello")
      }
    }
    let add_totalCost = sum_totalCost.reduce((a, b) => {
      return a + b;
    });
    let add_roinumerator = roi_numerator.reduce((a, b) => {
      return a + b;
    });
    let result = (add_roinumerator / add_totalCost) * 100;
    this.setState(
      produce((prevState) => {
        prevState.data.Promotions[promotion_index].Roi = !result ? 0 : result.toFixed(2) * 1;
      }),
      ()=>this.grnd_total(promotion_index)
      );
    
    // setTimeout(() => {
      
      
    // }, 0);

  }

  grnd_total(promotion_index) {

    try {
      // this.setState({forceState:false})
      this.grandTotalCalculation(promotion_index)
    }
    catch (e) {
    }
  }

  grandTotalCalculation=(promotion_index) => {
    const { data } = this.state;

    let gton = [0];
    let baseline = [0];
    let totalvol = [0];
    let totalcost = [0];
    let roi = [0];
    let incvol = [0];
    let activatedaws = [0];
    let totalactivatedvol = [0];
    // let activatedweeks = [0];
    let postvol = [0];
    let dndsvol = [0];
    let roinumerator = [0];
    let promotion_basedCost = [0];
    data.Promotions.forEach((e, i) => {
      e.SkuVolumeAnalysis.forEach((elem, j) => {
        let parsedtotal_cost = parseFloat(elem.TotalCost);
        baseline.push(elem.Baseline)
        totalvol.push(parseFloat(elem.TotalVolume))
        totalcost.push(parsedtotal_cost)
        incvol.push(parseFloat(elem.IncVolume))
        activatedaws.push(elem.ActivatedAws)
        totalactivatedvol.push(parseFloat(elem.TotalActivatedVolume))
        postvol.push(elem.PostAws)
        dndsvol.push(parseFloat(elem.DndsVolume))
        let extraprofit = (parseFloat(elem.IncVolume)) * elem.GpTon * 1000;
        let sku_roinumerator = extraprofit - parsedtotal_cost;
        roinumerator.push(parseFloat(sku_roinumerator))
        gton.push(extraprofit)
        if (promotion_index === i) {
          promotion_basedCost.push(parsedtotal_cost)

        }
      })
      roi.push(parseFloat(e.Roi))

    })
    let gton_result = gton.reduce((a, b) => { return a + b })
    let totalactivatedvol_result = totalactivatedvol.reduce((a, b) => { return a + b })
    let baseline_result = baseline.reduce((a, b) => { return a + b })
    let totalvol_result = totalvol.reduce((a, b) => { return a + b })
    let totalcost_result = totalcost.reduce((a, b) => { return a + b })
    // let roi_result = roi.reduce((a, b) => { return a + b })
    let incvol_result = incvol.reduce((a, b) => { return a + b })
    let activatedaws_result = activatedaws.reduce((a, b) => { return a + b })
    // let activatedweeks_result = activatedweeks.reduce((a, b) => { return a + b })
    let postvol_result = postvol.reduce((a, b) => { return a + b })
    let dndsvol_result = dndsvol.reduce((a, b) => { return a + b })
    let roinumerator_result = roinumerator.reduce((a, b) => { return a + b })
    let promotion_basedCostResult = promotion_basedCost.reduce((a, b) => { return a + b })
    let finalTcost = parseFloat(promotion_basedCostResult.toFixed(2))
    let finalBaseline = parseFloat(baseline_result.toFixed(2))
    let finalTVol = parseFloat(totalvol_result.toFixed(2))
    let finalUpperTcost = parseFloat(totalcost_result.toFixed(2))
    let totalRow_roi = (roinumerator_result / totalcost_result) * 100
    let finalTRow = parseFloat(totalRow_roi.toFixed(2))
    let finalTIncVol = parseFloat(incvol_result.toFixed(2))
    let finalActVol = parseFloat(totalactivatedvol_result.toFixed(2))
    let finalPostVol = parseFloat(postvol_result.toFixed(2))
    let finalDnds = parseFloat(dndsvol_result.toFixed(2))
    let finalAws = parseFloat(activatedaws_result.toFixed(2))
    
      this.setState(
        produce((prevState) => {

          let changeObject = Object.create(this.state.data);
          prevState.data = changeObject;
          
          prevState.data.Promotions[promotion_index].TotalCost = finalTcost;
          prevState.data.GpTon = gton_result.toFixed(2) * 1;
          prevState.data.Baseline = finalBaseline;
          prevState.data.TotalVolume = finalTVol;
          prevState.data.TotalCost = finalUpperTcost;
          prevState.data.Roi = !totalRow_roi ? 0 : finalTRow;
          prevState.data.IncVolume = finalTIncVol;
          prevState.data.ActivatedAws = finalAws;
          prevState.data.TotalActivatedVolume = finalActVol;
          prevState.data.PostVolume = finalPostVol;
          prevState.data.DndsVolume = finalDnds;
          
        }),
        () => {
          this.save_propso_in_idb(gton_result)
        }
      )
    
  }

  save_propso_in_idb(gton_result) {
    // this.setState({forceState:true})
    this.forceUpdate()
    const saveData = async (gton_result) => {
      try {
        if (!("indexedDB" in window)) {
          console.warn("IndexedDB not supported");
          return;
        }

        const dbName = "gt_form";
        const storeName = "product_store";
        const version = 1; //versions start at 1

        const db = await openDB(dbName, version, {
          upgrade(db, oldVersion, newVersion, transaction) {
            const store = db.createObjectStore(storeName);       // eslint-disable-line
          }
        });
        const tx = await db.transaction(storeName, "readwrite");
        const store = await tx.objectStore(storeName);
      
        let data = this.props.draftData?.PreOpso;

        data.GpTon = this.state.data?.GpTon
        data.Baseline = this.state.data?.Baseline
        data.TotalVolume = this.state.data?.TotalVolume
        data.TotalCost = this.state.data?.TotalCost
        data.Roi = this.state.data?.Roi
        data.IncVolume = this.state.data?.IncVolume
        data.ActivatedAws = this.state.data?.ActivatedAws
        data.TotalActivatedVolume = this.state.data?.TotalActivatedVolume
        // data.ActivityDuration= activatedweeks_result;
        data.ActivatedAws = this.state.data?.ActivatedAws
        data.PostVolume = this.state.data?.PostVolume
        data.DndsVolume = this.state.data?.DndsVolume
     
        const value = await store.put({ key: "pre_123", "value": data }, "preopso_detail");       // eslint-disable-line
      
        await tx.dones;


      } catch (e) {
        // alert(e.message)
        console.warn(e.message)
      }
    }

    saveData(gton_result)

  }
  norm_typeChange = (e) => {
    const {
     
      data,
    } = this.state;
    if (e) {
      data.Promotions.forEach((element, promotion_index) => {
        element.SkuVolumeAnalysis.forEach((item, i) => {
         
          let value = e.value;
          let label = e.label;
          this.setState(
            produce((prevState) => {
              prevState.data.Promotions[promotion_index].SkuVolumeAnalysis[
                i
              ].NormType = value;
              prevState.data.Promotions[promotion_index].NormType = value;
              prevState.selectedSkuNormType_label = label;
            }),
            () =>
              this.totalVol(
                40,
                10,
                element.SkuVolumeAnalysis[i],
                promotion_index,
                i
              ) // here sequesncy is pre activated weeks, activated weks, dip weeks
          );
          //  }
        });
      });
    }
  };

  sku_normChange = (e, prom_index, sku_index) => {
    const {
    
      data,
    } = this.state;
    if (sku_index) {
      let value = e.target.value;
      this.setState(
        produce((prevState) => {
          let dataObject1 = Object.create(data);
          prevState.data = dataObject1;
          prevState.data.Promotions[prom_index].SkuVolumeAnalysis[
            sku_index
          ].Norm = value * 1;
          prevState.data.Promotions[prom_index].Norm = value * 1;
        }),
        () => this.dndsVal(data.Promotions[prom_index].SkuVolumeAnalysis, prom_index, sku_index, data.ActivityDuration)
        // here sequesncy is pre activated weeks, activated weks, dip weeks
      );
    } else {


      data.Promotions[prom_index].SkuVolumeAnalysis.forEach((item, i) => {
        let value = e.target.value;
        this.setState(
          produce((prevState) => {
            let dataObject1 = Object.create(data);
            prevState.data = dataObject1;
            prevState.data.Promotions[prom_index].SkuVolumeAnalysis[
              i
            ].Norm = value;
            prevState.data.Promotions[prom_index].Norm = value;
          }),
          () => this.dndsVal(item, prom_index, i, this.state.data.ActivityDuration) // here sequesncy is pre activated weeks, activated weks, dip weeks
        );
      });
    }
  };

  currentNormChange = (e, index, item) => {
    let value = e.target.value;
    let isLastIndex;
    this.setState(
      produce((prevState) => {
        const objectNorm1 = Object.create(this.state.data);
        prevState.data = objectNorm1;
        prevState.data.Promotions[index].Norm = value;
        prevState.data.Promotions[index].SkuVolumeAnalysis.forEach((sku_elem, sku_i) => {
          prevState.data.Promotions[index].SkuVolumeAnalysis[sku_i].Norm = value;
          isLastIndex = prevState.data.Promotions[index].SkuVolumeAnalysis.indexOf(prevState.data.Promotions[index]
            .SkuVolumeAnalysis[prevState.data.Promotions[index].SkuVolumeAnalysis.length - 1]) === sku_i
             
          });

      }), () => {
        if (value === '') {
          return
        } else {
          if (isLastIndex) {
            this.projectCodeMerger(value, item, index)
          }
        }
      }
    );
    // }  
  };
  currentNormTypeChange = (val, index) => {
    const { data } = this.state
    let value = val?.value;
    if (value) {
      this.state.data.Promotions[index].SkuVolumeAnalysis.forEach((sku_val, i) => {
        this.setState(
          produce((prevState) => {
            const objectNormType1 = Object.create(this.state.data);
            prevState.data = objectNormType1;
            prevState.data.Promotions[index].SkuVolumeAnalysis[
              i
            ].NormType = value;
          }),
          () => this.dndsVal(sku_val, index, i, data.ActivityDuration)
        );
      });
      this.setState(
        produce((prevState) => {
          const objectNormtype1 = Object.create(this.state.data);
          prevState.data = objectNormtype1;
          prevState.data.Promotions[index].NormType = value;
          if (value === "2a48252b-4179-4090-98ac-a437728d5ed6") {
            prevState.data.Promotions[index].ApplyUom = null
            prevState.data.Promotions[index].ApplyOn = "47bf77b7-8768-4718-9e42-9a36bc2bfcaf"
          } else if (value === "b2e41bb3-a11d-48f1-b041-b9c04c956e7a") {
            prevState.data.Promotions[index].ApplyOn = "47bf77b7-8768-4718-9e42-9a36bc2bfcaf"
          } else if (value === "608618a4-50a0-4b2c-bdb1-8eac4e5e3238") {
            // ToastsStore.success("by val")
            prevState.data.Promotions[index].ApplyOn = "6a9237fe-dcb2-41dc-88d7-1cc4b3ddfd1c"
          }
        })
      );
    }
  };

  collapse_sku=(sku_index, promotion_index)=> {
    const { data } = this.state;

    const updated = data;
    let current_sku =
      updated.Promotions[promotion_index].SkuVolumeAnalysis[sku_index];
    if (current_sku.expanded === true) {
      current_sku.expanded = false;
    } else {
      current_sku.expanded = true;
    }
    this.setState({ data: updated });
  }

  onKeyDown = (e) => {
    if (e.keyCode === 8) {
      this.setState({ noNewProject: true });
    }
  };

  newProject=(e, sku_index, promotion_index, item, is_norm) => {
    try {
      this.newProjectCalculation(e, sku_index, promotion_index, item, is_norm)
    } catch (e) {
      // ToastsStore.warning("Something went wrong please try again")
      CustomToast('warning', 'Something went wrong please try again')
    }
  }

  newProjectCalculation=(e, sku_index, promotion_index, item, is_norm)=>{
    const { data } = this.state;
   
    let selectedType = e?.value && e.value;
    let norm_value = e?.target?.value;
    let valueChange = e.value ? e.value : e.target.value;
    valueChange = parseFloat(valueChange);
    let myData = this.state.data;       // eslint-disable-line
    myData =
      myData.Promotions[promotion_index].SkuVolumeAnalysis[sku_index].Norm;
    if (e?.target?.value === "" || e?.target?.value == data.Promotions[promotion_index].Norm) {       // eslint-disable-line
      this.setState(
        produce((prevState) => {
          let extensibility = Object.create(this.state.data);
          prevState.data = extensibility;
          prevState.data.Promotions[promotion_index].SkuVolumeAnalysis[
            sku_index
          ].Norm = valueChange;
        })
      );
    } else {
      let current_Prom = data.Promotions[promotion_index];       // eslint-disable-line
      // let api_post = {
      //   ProjectCode: current_Prom.ProjectCode,
      //   NormType: current_Prom.NormType,
      //   Norm: current_Prom.SkuVolumeAnalysis[sku_index].Norm,
      //   MasterSku: [current_Prom.SkuVolumeAnalysis[sku_index].MasterSku],
      //   SlabType: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      //   Slabs: [
      //     {
      //       Norm: 0,
      //       SlabFrom: 0,
      //       SlabTo: 0,
      //     },
      //   ],
      // };
      // let _id = this.props.draftData?.guid;
      // let filtered = this.state.data;
      let newwArr = this.state.data;
      Object.isExtensible(newwArr);
      let sku = newwArr.Promotions[promotion_index].SkuVolumeAnalysis[sku_index];
      let push_in_existing_code = newwArr.Promotions.findIndex((element, i) => {
        let filtered_normtype;
        let filtered_norm;
        let norm;
        let skuNorm = element.SkuVolumeAnalysis.forEach((sku_element, sku_i) => {       // eslint-disable-line

          norm = parseFloat(sku_element.Norm);
          filtered_normtype = newwArr.Promotions[promotion_index].NormType
          filtered_norm = newwArr.Promotions[promotion_index].SkuVolumeAnalysis[sku_index].Norm
        })
        if (selectedType) {
          filtered_norm = parseFloat(filtered_norm)
          return element.NormType === selectedType && norm === filtered_norm;
        } else {
          return element.NormType === filtered_normtype && norm === valueChange;
        }
      });

      if (push_in_existing_code !== -1) {
        newwArr.Promotions[push_in_existing_code].SkuVolumeAnalysis.push(sku);
        newwArr.Promotions[promotion_index].SkuVolumeAnalysis.splice(sku_index, 1);
        const object2 = Object.create(newwArr);
        this.setState(({ data }) => {
          const newData = object2;
          return { data: newData, };
        }, () => {
          push_in_existing_code !== -1 &&
          this.putValue(e, push_in_existing_code)
        }
        );
        // ToastsStore.warning('successfully merge with existing project code')
      CustomToast('warning', 'successfully merge with existing project code')
      } else {
        selectedProjectForNewCode = item;
        selectedMskuForNewCode = sku;
        selectedNormValueForNewProject = norm_value;
        selectedNormTypeValueForNewProject = selectedType;
        selectedmskuIndex = sku_index;
        selectedpromotionIndex = promotion_index;
        setTimeout(() => {
          this.props.post_preOpso_newProject(data.ActivityCode, data.Promotions[promotion_index].SkuVolumeAnalysis[sku_index].Norm);
        }, 100);

      }

      let lastIndex = data.Promotions.indexOf(data.Promotions[data.Promotions.length - 1])       // eslint-disable-line
   
    }

  }
/*
put value after merging
*/
  putValue(val, existing_index) {
    const { data } = this.state;
   
    if (val?.value) {
      let value = val.value;
      this.setState(
        produce((prevState) => {
          const put_Value = Object.create(data);
          prevState.data = put_Value;
          prevState.data.Promotions[data.Promotions.length - 1].SkuVolumeAnalysis[0].NormType = value;
          prevState.data.Promotions[data.Promotions.length - 1].NormType = value;
        }), () => this.grnd_total(existing_index)
      );
    } else {
      let value = val.target?.value;
      this.setState(
        produce((prevState) => {
          const put_Value11 = Object.create(data);
          prevState.data = put_Value11;
          if (existing_index !== -1) {
            prevState.data.Promotions[existing_index].SkuVolumeAnalysis[
              data.Promotions[existing_index].SkuVolumeAnalysis.length - 1
            ].Norm = value;
          } else {
            prevState.data.Promotions[
              data.Promotions.length - 1
            ].SkuVolumeAnalysis[0].Norm = value;
            prevState.data.Promotions[data.Promotions.length - 1].Norm = value;
          }
        }), () => this.grnd_total(existing_index)
      );
    }
  }

  componentDidMount() {
    let productData = []       // eslint-disable-line
    try {

      const getData = async () => {
        if (!("indexedDB" in window)) {
          console.warn("IndexedDB not supported");
          return;
        }
        const dbName = "gt_form";
        const storeName = "product_store";
        const version = 1; //versions start at 1

        const db = await openDB(dbName, version, {

        });
        let result = await db
          .transaction(storeName)
          .objectStore(storeName)
          .get("preopso_detail");

        let isRestrict = await db
          .transaction(storeName)
          .objectStore(storeName)
          .get("is_newPromotion");
        this.props.isRestrict_fromIdb(isRestrict && isRestrict.value)
        productData = result ? result.value : []

      }

      getData();



      this.props.get_allEnum();
      this.setState({
        data: this.props.draftData,
        metaData: this.props.draftData?.ActivityMetadata?.product_detail
          ?.promotion_type,
      });
      let current_data = this.props.draftData;
      for (let i = 0; i <= current_data?.PreOpso?.Promotions.length; i++) {
        if (current_data.PreOpso.Promotions[i]?.NormType === "2a48252b-4179-4090-98ac-a437728d5ed6") {
          this.setState(
            produce((prevState) => {
              const isext = Object.create(current_data?.PreOpso);
              prevState.data = isext;
              prevState.data.Promotions[i].ApplyOn =
                "47bf77b7-8768-4718-9e42-9a36bc2bfcaf";
              prevState.isPercentageValue = true;
            })
          );
        }
        if (current_data?.PreOpso?.Promotions[i]) {
          this.setState(
            produce((prevState) => {
              const isext = Object.create(current_data?.PreOpso);
              prevState.data = isext;
            })
          );
        }
      }
    
      // isSaveDraft = true;
    
    } catch (e) {
    }
  }


  calculateHandle = (e) => {
    this.setState({ isLoading: true, isCalculationResult: true });
    // let promotionId = sessionStorage.getItem("activity_id");
    let calculate = {
      _id: this.props.draftData?.guid,
      PreOpso: {
        PreOpso: this.props.draftData.PreOpso,
      },
    };

    this.props.post_calculate_preOpso(calculate);
  };

  PreOpsoData(data, flag) {
    const saveData = async (data, flag) => {
      if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }

      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {
        upgrade(db, oldVersion, newVersion, transaction) {
          const store = db.createObjectStore(storeName);       // eslint-disable-line
        },
      });
      const tx = await db.transaction(storeName, "readwrite");
      const store = await tx.objectStore(storeName);
      const value = await store.put(
        { key: "pre_123", value: data },
        "preopso_detail"
      );
      const isSave = await store.put(
        { key: "draft_123", value: flag },
        "is_draft_saved"
      );
      // }
      await tx.dones;

      let resp;
      let txs;
      let obj;
      resp = await db;
      txs = await resp.transaction(storeName);
      obj = await txs.objectStore(storeName);
      let productDataResult = await obj.get(value);
      let draft = await obj.get(isSave);       // eslint-disable-line
      preOpsoData = productDataResult ? productDataResult.value : [];
      draft = draft ? draft.value : [];
      setTimeout(() => {
        this.props.call_back(this.props.draft_state === true ? true : flag);
      }, 100);
    };

    saveData(data, flag);
    
    // isSaveDraft = false;
  }

  componentDidUpdate(prevProps, prevState) {

    if (prevProps.calculatedData !== this.props.calculatedData) {
      if (this.props.calculatedData.guid) {
        // ToastsStore.success("calculate api success");
      CustomToast('success', 'calculate api success')
      const {draftData }   = this.props
      draftData.PreOpso = this.props.calculatedData?.PreOpso
        this.setState({
          data: this.props.calculatedData?.PreOpso,
          isLoading: false,
          iscalc: true,
          trash: true
        })
        setTimeout(() => {
          this.PreOpsoData(this.props.calculatedData?.PreOpso, true)
        }, 800);

      } else {    
        this.setState({ isLoading: false });
      }
    }
    if (prevProps.calculationError !== this.props.calculationError) {
      let data = this.props.calculationError?.PreOpso?.Promotions &&
        Object.entries(this.props.calculationError?.PreOpso?.Promotions)
      data && data.forEach(([key, value]) => {
        let arr = Object.entries(value)
        arr.forEach(([keys, values]) => {
          // ToastsStore.error(`${keys} ${values[0]}`)
          CustomToast('error', `${keys} ${values[0]}`)
        })
      })
      this.setState({ isLoading: false })
    }
    if (this.state.data !== prevState.data) {
      prevState.data?.Promotions !== undefined
        ? this.PreOpsoData(this.props.draftData?.PreOpso, true)
        : void 0;
      prevState.data?.Promotions !== undefined && this.props.isRestrict_fromIdb(true,true)

    }

    if (this.props.newProject !== prevProps.newProject) {
      const { data } = this.state
      if (this.props.newProject?.io_code) {
        this.addnewMsku(this.props.newProject?.io_code, this.props.newProject?.io_code_id)
        let index = data.Promotions.indexOf(data.Promotions[data.Promotions.length - 1])
        this.setState(produce(prevState => {
          let isextensive_obj = Object.create(data);
          prevState.data = isextensive_obj;
          prevState.data.Promotions[index].ProjectCode = this.props.newProject?.io_code
        }))

        // ToastsStore.success(`New project code "${this.props.newProject?.io_code}" is added`)
        CustomToast('success', `New project code "${this.props.newProject?.io_code}" is added`)

      } 
    }

    if ((this.props.enumData !== prevProps.enumData) && (!this.props.draftData?.PreOpso?.Promotions[0]?.SlabType
      && this.props.draftData?.PreOpso?.Promotions[0]?.Slabs)) {
    
      this.setState(produce(prevState => {
        // this.setState({switch:false,checked:false})

        let isobjectextensive = this.state.data;
        prevState.data = isobjectextensive;
        prevState.data.Promotions.forEach((item, index) => {
          prevState.data.Promotions[index].SlabType = "795f46df-01a3-48f9-9143-06ea6c2cf658";
          prevState.switch = false;
          prevState.checked = false
        })
      }))
    }

    if (prevProps.promoCSVData !== this.props.promoCSVData) {
      CustomToast('success', 'Pre-opso calculated successfully from CSV')
      const {draftData }   = this.props
      draftData.PreOpso = this.props.promoCSVData
        this.setState({
          data: this.props.promoCSVData,
          isLoading: false,
          trash: true
        })
        setTimeout(() => {
          this.PreOpsoData(this.props.promoCSVData, true)
        }, 800);
    }
  }

  addnewMsku = (io_code, code_id) => {
    const { data } = this.state
    let newwArr = this.state.data
    let item = selectedProjectForNewCode;
    let sku = selectedMskuForNewCode;

    let lastIndex = data.Promotions.indexOf(data.Promotions[data.Promotions.length - 1])       // eslint-disable-line

    newwArr.Promotions.push({
      ApplyOn: selectedNormTypeValueForNewProject === "608618a4-50a0-4b2c-bdb1-8eac4e5e3238" ? "6a9237fe-dcb2-41dc-88d7-1cc4b3ddfd1c" : item.ApplyOn,
      ApplyUom: item.ApplyUom,
      BudgetRestriction: item.BudgetRestriction,
      BuyFrom: item.BuyFrom,
      BuyTo: item.BuyTo,
      BuyType: item.BuyType,
      BuyUom: item.BuyUom,
      DetailOfOffer: item.DetailOfOffer,
      Norm: item.Norm,
      NormType: item.NormType,
      ProjectCode: io_code,
      ProjectCodeId: code_id,
      Roi: item.Roi,
      TotalCost: item.TotalCost,
      SkuVolumeAnalysis: [sku],
    })
    newwArr.Promotions[selectedpromotionIndex].SkuVolumeAnalysis.splice(selectedmskuIndex, 1);

    this.setState(produce(prevState => {
      let isExtensibleProm = Object.create(this.state.data);
      prevState.data = isExtensibleProm;
      prevState.data = newwArr;
      prevState.selectedProjectForNewCode = undefined;
      prevState.selectedMskuForNewCode = undefined;
      if (selectedNormValueForNewProject) {
        prevState.data.Promotions[prevState.data.Promotions.length - 1].Norm = selectedNormValueForNewProject
        prevState.data.Promotions[prevState.data.Promotions.length - 1]
          .SkuVolumeAnalysis[0].Norm = selectedNormValueForNewProject;
      } else {

        prevState.data.Promotions[prevState.data.Promotions.length - 1].NormType = selectedNormTypeValueForNewProject
        prevState.data.Promotions[prevState.data.Promotions.length - 1]
          .SkuVolumeAnalysis[0].NormType = selectedNormValueForNewProject;
      }
    }), () => {
      let is_last_index = data.Promotions.length-1
      this.dndsVal(data.Promotions[is_last_index].SkuVolumeAnalysis[0], is_last_index, 0, data.ActivityDuration,'dd')
        setTimeout(() => {
          
           this.props.call_back(true, 'callSaveDraft')
        }, 100);
       })

  }
  handleSlabFromChange = (e, childIndex, index) => {
    let value = e.target.value;
    this.setState(
      produce((prevState) => {
        let extensive = Object.create(this.state.data);
        prevState.data = extensive;
        prevState.data.Promotions[index].Slabs[childIndex].SlabFrom = value;
      })
    );
  };

  handleSlabToChange = (e, childIndex, index) => {
    let value = e.target.value;
    this.setState(
      produce((prevState) => {
        let extensive = Object.create(this.state.data);
        prevState.data = extensive;
        prevState.data.Promotions[index].Slabs[childIndex].SlabTo = value;
      })
    );
  };

  handleSlabNormChange = (e, childIndex, index) => {
    let value = e.target.value;
    this.setState(
      produce((prevState) => {
        let extensive = Object.create(this.state.data);
        prevState.data = extensive;
        prevState.data.Promotions[index].Slabs[childIndex].Norm = value;
        let calc_norm = [];
        let cont = [];
        prevState.data.Promotions[index].Slabs.forEach((e, i) => {
          let first_multiply = e.Norm * e.Contribution;
          calc_norm.push(first_multiply);
          cont.push(e.Contribution);
        });
        let sum = calc_norm.reduce((a, b) => {
          return a + b;
        });
        let cont_sum = cont.reduce((a, b) => {
          return a + b;
        });
        let result = sum / cont_sum;
        prevState.data.Promotions[index].Norm = result.toFixed(2) * 1
        prevState.data.Promotions[index].SkuVolumeAnalysis.forEach(
          (elem, ind) => {
            prevState.data.Promotions[index].SkuVolumeAnalysis[
              ind
            ].Norm = parseFloat(result.toFixed(2) * 1);
          }
        );
      }), () => {

        this.state.data.Promotions[index].SkuVolumeAnalysis.forEach((skus, ind) => {

          this.dndsVal(this.state.data?.Promotions[index].SkuVolumeAnalysis[ind], index, ind, this.state.data?.ActivityDuration)
        })
      }

    );
 
  };

  handleSlabContChange = (e, childIndex, index) => {

    let value = e.target.value;
    value.substr(0, 1)
    value = parseInt(value);
    this.setState(
      produce((prevState) => {
        let extensive = Object.create(this.state.data);
        prevState.data = extensive;
        prevState.data.Promotions[index].Slabs[childIndex].Contribution = !value ? 0 : value;
        let calc_norm = [];
        let cont = [];
        prevState.data.Promotions[index].Slabs.forEach((e, i) => {
          let first_multiply = e.Norm * e.Contribution;
          calc_norm.push(first_multiply);
          cont.push(e.Contribution);
        });
        let sum = calc_norm.reduce((a, b) => {
          return a + b;
        });
        let cont_sum = cont.reduce((a, b) => {
          return a + b;
        });
        let result = sum / cont_sum;
        prevState.data.Promotions[index].Norm = result.toFixed(2) * 1
        prevState.data.Promotions[index].SkuVolumeAnalysis.forEach(
          (elem, ind) => {
            prevState.data.Promotions[index].SkuVolumeAnalysis[ind].Norm = parseFloat(result.toFixed(2) * 1);
            prevState.data.Promotions[index].SkuVolumeAnalysis[ind].Contributions[childIndex] = value;
          }
        );
      }),
      () => {

        this.state.data.Promotions[index].SkuVolumeAnalysis.forEach((skus, ind) => {

          this.dndsVal(this.state.data.Promotions[index].SkuVolumeAnalysis[ind], index, ind, this.state.data.ActivityDuration)
        })
      }
    );

  };
  handleSkuSlabContChange = (e, index, childIndex, contIndex) => {
    let value = e === false ? 0 : e.target.value;
    value = parseInt(value);
    this.setState(
      produce((prevState) => {
        let extensiveCont = Object.create(this.state.data);
        prevState.data = extensiveCont;
        prevState.data.Promotions[index].SkuVolumeAnalysis[childIndex].Contributions[contIndex] = !value ? 0 : value;
        let calc_norm = [];
        let cont = [];
        prevState.data.Promotions[index].Slabs.forEach((e, slab_ind) => {
          prevState.data.Promotions[index].SkuVolumeAnalysis[childIndex].Contributions.forEach((elem, cont_ind) => {
            if (slab_ind === cont_ind) {
              let contr = !elem ? 0 : elem
              let first_multiply = e.Norm * contr;
              calc_norm.push(first_multiply);
              cont.push(contr);
            }
          })
        });
        let sum = calc_norm.reduce((a, b) => {
          return a + b;
        });
        let cont_sum = cont.reduce((a, b) => {
          return a + b;
        });
        let result = sum / cont_sum;
        prevState.data.Promotions[index].SkuVolumeAnalysis[childIndex].Norm = parseFloat(result.toFixed(2) * 1)

        e === false &&
          prevState.data.Promotions[index].SkuVolumeAnalysis.forEach((e, i) => {

            prevState.data.Promotions[index].SkuVolumeAnalysis[i].Contributions[childIndex] = value;
          });
      }), () => this.dndsVal(this.state.data.Promotions[index].SkuVolumeAnalysis[childIndex], index, childIndex, this.state.data.ActivityDuration)
    );
  
  };
  handleAddSlabs = (index, norm) => {
    this.setState(
      produce((prevState) => {
        let extensive = Object.create(this.state.data);
        prevState.data = extensive;
        prevState.data.Promotions[index].Slabs.push({
          SlabFrom: 0,
          SlabTo: 0,
          Norm: norm,
          Contribution: 0,
        });
        prevState.data.Promotions[index].SkuVolumeAnalysis.forEach((elem,ind) => {
          prevState.data.Promotions[index].SkuVolumeAnalysis[ind].Contributions.push(0)
        })
      })
    );
  };

  handleRemoveSlabs = (childIndex, index) => {
    this.setState(
      produce((prevState) => {
        let extensive = Object.create(this.state.data);
        prevState.data = extensive;
        prevState.data.Promotions[index].Slabs.splice(childIndex, 1);
        prevState.data.Promotions[index].SkuVolumeAnalysis.forEach(element => {
            let del_item = element.Contributions;
            del_item.splice(childIndex,1)
        });
        // [
        //   childIndex
        // ].Contributions.splice(childIndex, 1);
      })
    );
    // this.handleSkuSlabContChange(false, index, childIndex, childIndex);
  };

  handleANPTotalValueChange = (e) => {
    const { data } = this.state;
    let value = (e.target.value) * 1
    this.setState(produce(prevState => {
      let isextObject = Object.create(data);
      prevState.data = isextObject;
      prevState.data.Promotions[0].TotalVolume = value
    }))
  }

  handleANPTotalCostChange = (e) => {
    const { data } = this.state;
    let value = (e.target.value) * 1
    this.setState(produce(prevState => {
      let isextObject = Object.create(data);
      prevState.data = isextObject;
      prevState.data.Promotions[0].TotalCost = value
    }))
  }
  handleANPOtherDetailsChange = (e) => {
    const { data } = this.state;
    let value = e.target.value
    this.setState(produce(prevState => {
      let isextObject = Object.create(data);
      prevState.data = isextObject;
      prevState.data.Promotions[0].OtherDetails = value
    }))
  }

  buyTypeSelectChange = (value, index) => {

    if (value === "795f46df-01a3-48f9-9143-06ea6c2cf658") {
      this.setState(produce(prevState => {
        prevState.data.Promotions[index].ApplyUom = null
        prevState.data.Promotions[index].BuyUom = null
        prevState.data.Promotions[index].ApplyOn = "47bf77b7-8768-4718-9e42-9a36bc2bfcaf"
      })
      )
    }
    if (value) {
      this.setState(
        produce((prevState) => {
          let objectbuytype1 = Object.create(this.state.data);
          prevState.data = objectbuytype1;
          prevState.data.Promotions[index].BuyType = value;
          value === 'e7130818-5d92-4618-8107-efb0d3c623c4' &&
            prevState.data.Promotions[index].BuyUom === '48568dac-993e-4d7d-9647-374aa1e136eb' ?
            prevState.data.Promotions[index].BuyUom = null : void 0;
      
        })
      );
    }
  };

  buyUomSelectChange = (value, index) => {
    const { data } = this.state
    if (value) {
      this.setState(
        produce((prevState) => {
          let objectbuyuom1 = Object.create(this.state.data);
          prevState.data = objectbuyuom1;
          prevState.data.Promotions[index].BuyUom = value;

          if (value === "795f46df-01a3-48f9-9143-06ea6c2cf658") {
            prevState.data.Promotions[index].ApplyUom = null
            prevState.data.Promotions[index].BuyUom = null
          }
          if (data.Promotions[index].NormType !== "2a48252b-4179-4090-98ac-a437728d5ed6" &&
            data.Promotions[index].BuyType === "e7130818-5d92-4618-8107-efb0d3c623c4") {

            if (value === '4f031ace-badf-4340-a2e9-dd7363fbc3de') { //pc
              prevState.data.Promotions[index].ApplyUom =
                'd1496288-73be-4de8-a615-8d568e8c6b4f'
            } else if (value === 'bcaed8e2-588d-446d-982f-66987e903dd3') { //cs
              prevState.data.Promotions[index].ApplyUom = '8a3e952e-ec37-4b56-b869-be65efaf4ac2'
            } else if (value === 'c5ddb6ef-847e-44fc-9950-debe5a1d3793' &&
              data.Promotions[index].NormType !== "b2e41bb3-a11d-48f1-b041-b9c04c956e7a") { //kg
              prevState.data.Promotions[index].ApplyUom = 'd2f775a7-5320-4b0b-b3c4-45dd8378bf47'

              prevState.data.Promotions[index].ApplyOn = 'ddc4666c-6dc8-427e-a077-e4aa6bfc1273'

            } else if (value === 'e907be85-2af9-4ca6-9c94-79dcde6507a1' &&
              data.Promotions[index].NormType !== "b2e41bb3-a11d-48f1-b041-b9c04c956e7a") { // ltr
              prevState.data.Promotions[index].ApplyUom = '8f031b99-3e78-4374-88e7-5999a1ee81a7'
              prevState.data.Promotions[index].ApplyOn = 'df316d1d-1486-4e37-87a3-f2fb2315d8b0'
            }
          }

        })
      );
    }
  };

  applyUomSelectChange = (value, index) => {
    if (value) {
      this.setState(
        produce((prevState) => {
          let objectapplyuom1 = Object.create(this.state.data);
          prevState.data = objectapplyuom1;
          prevState.data.Promotions[index].ApplyUom = value;
        })
      );
    }
  };

  applyOnSelectChange = (value, index) => {
    if (value) {
      this.setState(
        produce((prevState) => {
          let objectapplyon1 = Object.create(this.state.data);
          prevState.data = objectapplyon1;
          prevState.data.Promotions[index].ApplyOn = value;
        })
      );
    }
  };

  otherDetailsChange = (value, index) => {
    this.setState(
      produce((prevState) => {
        let newobjct = Object.create(this.state.data);
        prevState.data = newobjct;
        prevState.data.Promotions[index].OtherDetails = value;
      })
    );
  };

  buyFromChange = (e, index) => {
    let value = e.target.value;
    value = parseFloat(value);
    this.setState(
      produce((prevState) => {
        let objectBuyFrom1 = Object.create(this.state.data);
        prevState.data = objectBuyFrom1;
        prevState.data.Promotions[index].BuyFrom = value;
      })
    );
  };
  buyToChange = (e, index) => {
    let value = e.target.value;
    value = parseFloat(value);
    this.setState(
      produce((prevState) => {
        let objectBuyTo121 = Object.create(this.state.data);
        prevState.data = objectBuyTo121;
        prevState.data.Promotions[index].BuyTo = value;
      })
    );
  };
  budgetRestrictionChange = (e, index) => {
    let value = e.target.value;
    this.setState(
      produce((prevState) => {
        let objectBuyTo121 = Object.create(this.state.data);
        prevState.data = objectBuyTo121;
        prevState.data.Promotions[index].BudgetRestriction = value;
      })
    );
  };

  projectCodeMerger = (e, item, index) => {
    try {
      const { data } = this.state
      if (e.value) {
        let projectCode_index = data.Promotions.findIndex((element, ind) => {
          return (e.value !== data.Promotions[index].NormType) &&
            (element.NormType === e.value) && (element.Norm == item.Norm)       // eslint-disable-line
        })

        if (projectCode_index !== -1 && data.Promotions.length > 1 && this.props.draftData?.IsExtended!==true) {
          let filtered_data = data.Promotions[index].SkuVolumeAnalysis;
          // let entries = Object.entries(filtered_data)
          // let arr = []
          filtered_data.forEach((elem, i) => {

            this.setState(produce(prevState => {
              data.Promotions[projectCode_index].SkuVolumeAnalysis.push(elem)
            }))
          })
          this.setState(produce(prevState => {
            prevState.data.Promotions[projectCode_index].BuyType = item.BuyType
            if (prevState.data.Promotions[projectCode_index].NormType === "608618a4-50a0-4b2c-bdb1-8eac4e5e3238") {
              // ToastsStore.success("by val success")
              CustomToast('success', 'by val success')
              prevState.data.Promotions[projectCode_index].ApplyOn = "6a9237fe-dcb2-41dc-88d7-1cc4b3ddfd1c"
            } else {
              prevState.data.Promotions[projectCode_index].ApplyOn = item.ApplyOn
            }
            prevState.data.Promotions[projectCode_index].ApplyUom = item.ApplyUom
            prevState.data.Promotions[projectCode_index].BudgetRestriction = item.BudgetRestriction
            prevState.data.Promotions[projectCode_index].BuyFrom = item.BuyFrom
            prevState.data.Promotions[projectCode_index].BuyTo = item.BuyTo
            prevState.data.Promotions[projectCode_index].BuyUom = item.BuyUom
            prevState.data.Promotions[projectCode_index].DetailOfOffer = item.DetailOfOffer
            prevState.data.Promotions[projectCode_index].Norm = item.Norm
            prevState.data.Promotions[projectCode_index].Roi = item.Roi
            prevState.data.Promotions[projectCode_index].ProjectCode = item.ProjectCode
            prevState.data.Promotions[projectCode_index].ProjectCodeId = item.ProjectCodeId

            let filteredPromotion = data.Promotions
            filteredPromotion.splice(index, 1)
            prevState.data.Promotions = filteredPromotion
          }))

        } else {
          this.currentNormTypeChange(e, index)
        }
      } else {
        let projectCode_index = data.Promotions.findIndex((element, ind) => {
          return (element.Norm == e) && (element.NormType === item.NormType) && (ind !== index)       // eslint-disable-line
        })
        if (projectCode_index !== -1 && data.Promotions.length > 1 && this.props.draftData?.IsExtended!==true) {
          let filtered_data = data.Promotions[index].SkuVolumeAnalysis;
          // let arr = []
          filtered_data.forEach((elem, i) => {
            this.setState(produce(prevState => {
              data.Promotions[projectCode_index].SkuVolumeAnalysis.push(elem)
            }))
          })
          this.setState(produce(prevState => {
            prevState.data.Promotions[projectCode_index].BuyType = item.BuyType
            prevState.data.Promotions[projectCode_index].ApplyOn = item.ApplyOn
            prevState.data.Promotions[projectCode_index].ApplyUom = item.ApplyUom
            prevState.data.Promotions[projectCode_index].BudgetRestriction = item.BudgetRestriction
            prevState.data.Promotions[projectCode_index].BuyFrom = item.BuyFrom
            prevState.data.Promotions[projectCode_index].BuyTo = item.BuyTo
            prevState.data.Promotions[projectCode_index].BuyUom = item.BuyUom
            prevState.data.Promotions[projectCode_index].DetailOfOffer = item.DetailOfOffer
            prevState.data.Promotions[projectCode_index].Norm = item.Norm
            prevState.data.Promotions[projectCode_index].Roi = item.Roi
            prevState.data.Promotions[projectCode_index].ProjectCode = item.ProjectCode
            prevState.data.Promotions[projectCode_index].ProjectCodeId = item.ProjectCodeId

            let filteredPromotion = data.Promotions
            filteredPromotion.splice(index, 1)
            prevState.data.Promotions = filteredPromotion

          }),
            () => {
              // ToastsStore.success('Project code succesfully merge')
              CustomToast('success', 'Project code succesfully merge')
              this.calcluteNorm_afterMerge(index, e)
            }
          )

        } else {
          this.state.data.Promotions[index].SkuVolumeAnalysis.forEach((val, i) => {
            this.setState(
              produce((prevState) => {
                const objectNorm1 = Object.create(this.state.data);
                prevState.data = objectNorm1;
                prevState.data.Promotions[index].SkuVolumeAnalysis[i].Norm = e;
              }),
              () => {
                this.dndsVal(val, index, i, data.ActivityDuration)
              }
            );
          });
        }
      }
    }
    catch (e) {
    }
  }
  calcluteNorm_afterMerge = (index, e) => {
    this.state.data.Promotions[index] && this.state.data.Promotions[index].SkuVolumeAnalysis &&
      this.state.data.Promotions[index].SkuVolumeAnalysis.forEach((val, i) => {
        this.setState(
          produce((prevState) => {
            const objectNorm1 = Object.create(this.state.data);
            prevState.data = objectNorm1;
            prevState.data.Promotions[index].SkuVolumeAnalysis[i].Norm = e;
          }),
          () => {
            this.dndsVal(val, index, i, this.state.data.ActivityDuration)
          }
        );
        let lastIndex = this.state.data.Promotions[index].SkuVolumeAnalysis.indexOf(       // eslint-disable-line
          this.state.data.Promotions[index].SkuVolumeAnalysis[this.state.data.Promotions[index].SkuVolumeAnalysis
            .length - 1]
        ) === i
      });
  }

  changeSlabType = (index) => {
    this.setState(produce(prevState => {
      let isobject = Object.create(this.state.data);
      prevState.data = isobject;
      prevState.switch = !this.state.switch;
      prevState.checked = false;
      prevState.data.Promotions[index].SlabType = prevState.switch === false ?
        "795f46df-01a3-48f9-9143-06ea6c2cf658" : "e7130818-5d92-4618-8107-efb0d3c623c4"
      if (prevState.data.Promotions[index].SlabType === "795f46df-01a3-48f9-9143-06ea6c2cf658") {
        prevState.data.Promotions[index].BuyUom = null
      }
    }))
  }

  UNSAFE_componentWillMount() {
    this.props.draftData.PreOpso.Promotions.forEach((item, index) => {

      if (this.props.draftData.PreOpso.Promotions[index].SlabType === "e7130818-5d92-4618-8107-efb0d3c623c4") {
        this.setState({ switch: true, checked: true })
      }
    })
  }

  handleDownloadPromotionCSV = () => {
    let getdraft_id = window.location.pathname.substr(8);
    if(getdraft_id){
      this.props.downloadPromoCSV(getdraft_id)
    }
  }

  handleFileUpload = (data, fileInfo) => {
    let getdraft_id = window.location.pathname.substr(8);
    let isErrorCount = 0;
    let columnMissingCount = 0;
    let differentActivityCodeCount = 0;
    let currentMskuCount = 0;
    let totalCurrentMsku = 0;
    let normValue = 0;
    let mskuCodeErrorCount = 0;
    let normValueErrorCount = 0;
    var extension = fileInfo.name.split(".").pop().toLowerCase();
    var allowed = ["csv"];
    const randomString = Math.random().toString(36);
    if(allowed.indexOf(extension) === -1){
      CustomToast('error', "Invalid File Type!")
      return;
    }else{
      if(data.length){
        // console.log(data)
        data.forEach((item,ind)=>{
          if(item.hasOwnProperty('activity_code') && item.hasOwnProperty('baseline') && 
          item.hasOwnProperty('incremental_aws') && item.hasOwnProperty('msku_code') && 
          item.hasOwnProperty('norm') && item.hasOwnProperty('post_aws') && 
          item.hasOwnProperty('project_code')){
            if(item.activity_code === this.state.data.ActivityCode){
              if(ind === 0){
                normValue = item.norm
              }
              if(normValue !== item.norm && ind !== 0){
                normValueErrorCount++;
              }
              if(item.activity_code === ''){
                isErrorCount++;
              }
              if(item.project_code === ''){
                isErrorCount++;
              }
              if(item.post_aws === ''){
                isErrorCount++;
              }
              if(isNaN(item.baseline) || item.baseline <= 0){
                isErrorCount++;
              }
              if(isNaN(item.incremental_aws) || item.incremental_aws <= 0){
                isErrorCount++;
              }
              if(isNaN(item.norm) || item.norm <= 0){
                isErrorCount++;
              }
              if(isNaN(item.post_aws) || item.post_aws <= 0){
                isErrorCount++;
              }
              data.forEach((elm,indx)=>{
                if((item.msku_code === elm.msku_code) && indx !== ind){
                  mskuCodeErrorCount++;
                }
              })
            }else{
              differentActivityCodeCount++;
            }
          }else{
            columnMissingCount++;
          }
        })

        this.state.data.Promotions.forEach(projectCode=>{
          projectCode.SkuVolumeAnalysis.forEach(mskus=>{
            totalCurrentMsku++;
            data.forEach(item=>{
              if(mskus.Code === item.msku_code){
                currentMskuCount++;
              }
            })
          })
        })
        
        if(differentActivityCodeCount > 0){
          CustomToast('error',`Activity Code is different`);
          this.setState({
            csvFileReset: randomString,
          });
          return;
        }

        if(columnMissingCount > 0) {
          CustomToast('error',`Column missing from CSV`);
          this.setState({
            csvFileReset: randomString,
          });
          return;
        }

        if((data.length !== currentMskuCount) || totalCurrentMsku !== data.length){
          CustomToast('error',`Number of MSKUs are different`);
          this.setState({
            csvFileReset: randomString,
          });
          return;
        }

        if(mskuCodeErrorCount > 0) {
          CustomToast('error',`MSKUs is duplicated`);
          this.setState({
            csvFileReset: randomString,
          });
          return;
        }

        if(normValueErrorCount > 0) {
          CustomToast('error',`Norm values of MSKUs are not same`);
          this.setState({
            csvFileReset: randomString,
          });
          return;
        }

        if(isErrorCount > 0) {
          this.setState({
            CSVHasError:true,
            CSVData:data,
            csvFileReset: randomString,
          })
          return;
        }
        else{
          this.props.calculatePreopsoFromCSV(getdraft_id,data)
          this.setState({
            csvFileReset: randomString,
          });
        }
      }
    }
  }
  
  render() {
    const papaparseOptions = {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
    };
    const {    
      selectedBuyUom,    
      slabFrom
    } = this.state;
    const { enumData } = this.props;
    
    // let roi_average = [0];
    // let roiResult;
    // let dnds_total = undefined;
    // let dnds_arr = [0];
    let data = this.state.data ? this.state.data : this.props.draftData?.PreOpso
    return !data && !data?.Promotions && !enumData ? (
      <Loader flag={true} />
    ) : (
        <>
          <div style={this.state.isLoading === true ? { pointerEvents: 'none', cursor: 'pointer' } : void 0} >
            <div className="product_detail">
              <p>Promotion Detail</p>
            </div>
            <div className="label_id">
              <label for="prom"> Activity Code</label>
              <label for="prom" style={{ display: "block", paddingTop: "2.2vh" }}>
                {!data ? void 0 : data && data.ActivityCode}{" "}
              </label>
            </div>
            {this.props.draftData?.ActivityMetadata?.product_detail
          ?.promotion_type === "b0107ffd-5026-4011-bdc6-3bb2e5986332" ? (
              <>
                {!data
                  ? void 0
                  : data &&
                  data.Promotions.map((item, index) => {
                    return (
                      <ANP 
                      handleANPTotalValueChange={this.handleANPTotalValueChange} 
                      handleANPTotalCostChange={this.handleANPTotalCostChange}
                      handleANPOtherDetailsChange={this.handleANPOtherDetailsChange}
                      item={item}
                      isExtended={this.props.draftData?.IsExtended}
                      />
                    );
                  })}
              </>
            ) : (
                <>
                  {!data
                    ? void 0
                    : data &&
                    data.Promotions.map((item, index) => {
                      return (
                        <div className="promotion_main_page">
                          {
                            item?.Slabs && item?.Slabs?.length > 0 ? (
                                <SBB
                              budgetRestrictionChange={this.budgetRestrictionChange}
                              buyUomSelectChange={this.buyUomSelectChange}
                              otherDetailsChange={this.otherDetailsChange}
                              changeSlabType={this.changeSlabType}
                              handleSlabFromChange={this.handleSlabFromChange}
                              handleSlabToChange={this.handleSlabToChange}
                              handleSlabNormChange={this.handleSlabNormChange}
                              handleSlabContChange={this.handleSlabContChange}
                              handleRemoveSlabs={this.handleRemoveSlabs}
                              handleAddSlabs={this.handleAddSlabs}
                              item={item}
                              switched={this.state.switch}
                              checked={this.state.checked}
                              index={index}
                              enumData={enumData}
                              selectedBuyUom={selectedBuyUom}
                              slabFrom={slabFrom}
                              isExtended={this.props.draftData?.IsExtended}
                              />
                            
                             ) : (
                             
                             <TPR 
                             item={item}
                             budgetRestrictionChange={this.budgetRestrictionChange}
                             buyUomSelectChange={this.buyUomSelectChange}
                             applyUomSelectChange={this.applyUomSelectChange}
                             buyTypeSelectChange={this.buyTypeSelectChange}
                             selectedSkuNormType={this.state.selectedSkuNormType}
                             projectCodeMerger={this.projectCodeMerger}
                             otherDetailsChange={this.otherDetailsChange}
                             buyFromChange={this.buyFromChange}
                             currentNormChange={this.currentNormChange}
                             buyToChange={this.buyToChange}
                             applyOnSelectChange={this.applyOnSelectChange}
                             enumData={enumData}
                             index={index}
                             selectedBuyUom={this.state.selectedBuyUom}
                             selectedAppyOn={this.state.selectedAppyOn}
                             selectedAppyUom={this.state.selectedAppyUom}
                             selectedBuyType={this.state.selectedBuyType}
                             data={data}
                             stateselectedSkuNormType={this.state.stateselectedSkuNormType}
                             isExtended={this.props.draftData?.IsExtended}
                             />

                              )}

                          {item.SkuVolumeAnalysis.map((sku_item, sku_index) => {
                            return (
                              <MSKUS
                              sku_item={sku_item}
                              sku_index={sku_index}
                              item={item}
                              awsBaseline={this.state.awsBaseline}
                              data={data}
                              index={index}
                              selectedSkuNormType={this.state.selectedSkuNormType}
                              enumData={enumData}
                              collapse_sku={this.collapse_sku}
                              baselineChange={this.baselineChange}
                              awsChange={this.awsChange}
                              post_awsChange={this.post_awsChange}
                              handleSkuSlabContChange={this.handleSkuSlabContChange}
                              onKeyDown={this.onKeyDown}
                              newProject={this.newProject}
                              sku_normChange={this.sku_normChange}
                              currentNormTypeChange={this.currentNormTypeChange}
                              isExtended={this.props.draftData?.IsExtended}
                              formType={this.props.currentForm}
                              />
                              );
                          })}
                        </div>
                      );
                    })}

                  <TOTALROW
                  data={data}
                  />
                  <div className="lower_section">
                    {this.props.currentForm !== 'ic' &&
                      <button
                      title='Model will suggest AWS Baseline, Inc AWS, Post AWS and accordingly Total Vol, Total Cost, ROI and other related calculations for all Master SKUs based on its logic, according to the selected norm and norm type'
                      type="button"
                      className="calculate_btn"
                      style={this.state.isLoading === true ? { pointerEvents: 'none' } : void 0}
                      onClick={this.state.isLoading === false && this.calculateHandle}
                    >
                      {this.state.isLoading === true ? "Loading.." : "Get Machine Suggested ROI"}
                    </button>
                    }
                    <h2 className="statement">
                      Return On Investment (ROI) is{" "}
                      <span> {data && data.Roi}% </span>{" "}
                    </h2>
                  </div>
                </>
              )}
          </div>
          {
                this.props.currentForm === 'ic' ? 
                <div style={{display:'flex',position:'absolute',top:'60px',right:'150px'}}>
                  <div style={{marginRight:'12px'}} onClick={this.handleDownloadPromotionCSV}>
                    {
                      this.props.isPromoCSVFileDownloading ?
                      <img src={require('../../assets/gifs/Downloading.gif')} style={{ width: "26px", height: "31px" }} alt='' />
                      :
                      <img src={require('../../assets/images/CSV_download_icon.svg')} alt='' />

                    }
                  </div>
                  <div className='upload-image-container'>
                      <img src={require('../../assets/images/CSV_upload_icon.svg')} alt='' />
                      <div  key={this.state.csvFileReset || ''}>
                        <CSVReader cssInputClass="input-upload" accept='.csv' onFileLoaded={(data, fileInfo) => this.handleFileUpload(data, fileInfo)} parserOptions={papaparseOptions}/>
                      </div>
                    </div>
                </div>
                :
                null
              }

              {
                this.state.CSVHasError ? 
                <CSVErrorTable
                  isOpen={this.state.CSVHasError}
                  flagHandle={()=>{this.setState({CSVHasError:!this.state.CSVHasError})}}
                  data={this.state.CSVData}
                />
                :
                null
              }
        </>
      );
  }

}

// redux

const mapStateToProps = (state) => {
  return {
    enumData: state.CreatePromotionReducer.enumData,
    promotionData: state.CreatePromotionReducer.promotionData,
    calculatedData: state.CreatePromotionReducer.calculatedData,
    calculationError: state.CreatePromotionReducer.calcError,
    newProject: state.CreatePromotionReducer.newProject,
    draftData: state.CreatePromotionReducer.draftData,
    submitApproval: state.ApprovalReducer.submitApproval,
    error: state.ApprovalReducer.error,
    isPromoCSVFileDownloading:state.PromotionReducer.isPromoCSVFileDownloading,
    promoCSVData: state.PromotionReducer.promoCSVData,
    isCalculateCSVPromoloading: state.PromotionReducer.isCalculateCSVPromoloading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    get_allEnum: () => {
      return dispatch(CreatePromotion.get_allEnum());
    },
    post_calculate_preOpso: (data) => {
      return dispatch(CreatePromotion.post_calculate_preOpso(data));
    },
    post_preOpso_newProject: (activitycode, norm) => {
      return dispatch(CreatePromotion.post_preOpso_newProject(activitycode, norm));
    },
    downloadPromoCSV: (data) => {
      return dispatch(PromotionMiddleware.downloadPromoCSV(data));
    },
    calculatePreopsoFromCSV: (id,data) => {
      return dispatch(PromotionMiddleware.calculatePreopsoFromCSV(id,data));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Promotion);
